import BusLicensesPermitsTypeTable from "./view/BusLicensesPermitsTypeTable";

const BusinessLicencesPermits = () => {
  return (
    <>
      <BusLicensesPermitsTypeTable />
    </>
  );
};

export default BusinessLicencesPermits;
